module.exports = __webpack_public_path__ + "img/surprised.7bf6dd38.webp";